module.exports = __webpack_public_path__ + "static/media/bcg-pattern-static.2a1e2d26.svg";